
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ContactCTA = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  // Use a direct link to homepage with section if not on homepage
  const goldSectionLink = isHomePage ? "/#gold-section" : "/#gold-section";
  
  return <div className="text-center">
      <h2 className="text-2xl md:text-3xl font-serif font-semibold text-patrimoine-dark mb-6">Contactez-Nous</h2>
      <div className="w-24 h-1 bg-patrimoine-gold mx-auto mb-8"></div>
      <p className="text-lg text-patrimoine-muted max-w-3xl mx-auto mb-8">
        Découvrez comment <Link to={goldSectionLink} className="text-patrimoine-gold hover:underline font-medium">nos services</Link> peuvent vous aider à atteindre vos objectifs financiers. Prenez rendez-vous avec l'un de nos conseillers pour une consultation personnalisée.
      </p>
      <Link to="/contact" className="cta-button inline-block">Prendre Rendez-Vous</Link>
    </div>;
};

export default ContactCTA;
